import blue from "./markdown/blue";
import blueCyan from "./markdown/blueCyan";
import blueMountain from "./markdown/blueMountain";
import custom from "./markdown/custom";
import cyan from "./markdown/cyan";
import geekBlack from "./markdown/geekBlack";
import green from "./markdown/green";
import ink from "./markdown/ink";
import normal from "./markdown/normal";
import orangeHeart from "./markdown/orangeHeart";
import red from "./markdown/red";
import purple from "./markdown/purple";
import scienceBlue from "./markdown/scienceBlue";
import shanchui from "./markdown/shanchui";
import simple from "./markdown/simple";
import wechatFormat from "./markdown/wechatFormat";
import rose from "./markdown/rose";
import cuteGreen from "./markdown/cuteGreen";
import fullStackBlue from "./markdown/fullStackBlue";

import content from "./content.md";

import atomOneDark from "./code/atomOneDark";
import atomOneLight from "./code/atomOneLight";
import github from "./code/github";
import monokai from "./code/monokai";
import vs2015 from "./code/vs2015";
import xcode from "./code/xcode";

import macAtomOneDark from "./macCode/macAtomOneDark";
import macAtomOneLight from "./macCode/macAtomOneLight";
import macGithub from "./macCode/macGithub";
import macMonokai from "./macCode/macMonokai";
import macVs2015 from "./macCode/macVs2015";
import macXcode from "./macCode/macXcode";

import basic from "./basic";

export default {
  basic,
  style: {
    blue,
    blueMountain,
    blueCyan,
    normal,
    custom,
    cyan,
    geekBlack,
    green,
    ink,
    orangeHeart,
    purple,
    red,
    scienceBlue,
    shanchui,
    simple,
    wechatFormat,
    rose,
    cuteGreen,
    fullStackBlue,
  },
  code: {
    atomOneDark,
    atomOneLight,
    github,
    monokai,
    vs2015,
    xcode,
    macAtomOneDark,
    macAtomOneLight,
    macGithub,
    macMonokai,
    macVs2015,
    macXcode,
  },
  content,
};
